module.exports = __webpack_public_path__ + "static/media/se.fd663a70.svg";